export default "__VITE_ASSET__BZknZ9OM__"